<div class="col-lg-12 col-md-12 col-sm-12 mt-2 col-xs-12">
  <date-time-filter [startDateEnable]="true" [endDateEnable]="true" (sendPickerResult)="sendPickerResult($event)">
  </date-time-filter>
</div>
<!--withslot -->
@if (!withoutslot && packageData && packageData.slots) {
  <div class="col-sm-12 mt-2">
    <time-slots [slots]="packageData.slots" [key]="'slot_start_time'" [colorScheme]="colorScheme"
      (slotResult)="slotResult($event)">
    </time-slots>
  </div>
}
<!--withoutslot -->
@if (withoutslot) {
  <div class="font-weight-bold" style="margin: 15px;">
    <div class="mx-auto" style="width: 200px;">
      <button type="button" class="primary-btn bookBtn" (click)="updateSlot()">
        {{'button.lable.book' | translate | async}}
        <i class="fa fa-check ml-2" aria-hidden="true"></i>
      </button>
    </div>
  </div>
}